import { buildCommonTransfer } from "@/components/excel/schema/label/transfer/base";
import { SexOption } from "@/components/excel/schema/label/type/other";
export const OtherValueTransfer = {
  ...buildCommonTransfer(SexOption),
};
